import { withDependencies } from '@wix/thunderbolt-ioc'
import type { HasInteractionsRegistry } from './types'

const hasInteractionsRegistryFactory = (): HasInteractionsRegistry => {
	let hasInteractions = false

	return {
		setHasInteractions: () => {
			hasInteractions = true
		},
		getHasInteractions: () => hasInteractions,
	}
}

export const hasInteractionsRegistry = withDependencies([], hasInteractionsRegistryFactory)
